"use strict";

var LoggerInstance = require("js-logger").get("AccountFormHelper");

var DefaultBillingAndShippingAddressHelper = require("./DefaultBillingAndShippingAddressHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var Spinner = require("../client/Spinner");

var AccountDemographicsHelper = require("../commonComponents/AccountDemographicsHelper");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");
var RegExpHelper = require("../designer/RegExpHelper");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

// AccountFormHelper
module.exports = {
	getPrimaryCreateAccountFormId: function () {
		var $primaryForm = $("[data-component='createAccountForm']").filter(function () {
			// If we allow createAccountForm in any additional components outside of the standard one-form-per-page/account-state
			// rule, they can be added to this selector to ensure standard createAccount requests pull the right form.
			var parents = $(this).parents("[data-component='emailSubscriptionForm']");
			if (parents.length) {
				return false;
			}
			return true;
		}).first();

		return $primaryForm.attr("id");
	},

	getPrimaryAddressFormName: function () {
		var $createAccountForm = $("[data-component='createAccountAndCheckout'] [data-component='createAccountForm']");
		var hasCreateAccountForm = $createAccountForm.length;
		var hasAddressComponents = $createAccountForm.find("[data-component^='accountAddress']").length;
		var hasPrimaryAddressForm = hasCreateAccountForm && hasAddressComponents ? this.getPrimaryCreateAccountFormId() : null;
		var primaryAddressFormName = hasPrimaryAddressForm ? "createAccountForm" : null;

		return primaryAddressFormName;
	},

	// Used when all the data required to create an account is needed
	// options:
	// * shouldEncodePassword - should the password be url-encoded before being sent to SE. Default to yes.
	// * selector - used to identify which for we will use when gathering account demographics.
	// * accountFormId - used to identify the desired createAccountForm when multiple are on the page (ex: email subscription form)
	serializeDataNecessaryToCreateAnAccount: function (options) {
		var deferred = new $.Deferred();

		options = Object.assign({}, { shouldEncodePassword: true }, options || {});
		var data,
			mediaOutlet;

		data = this.serializeCreateAccountFormOnly(options);

		var selector = options.selector;
		var useSelectorFunction = (typeof options.selectorFunctionName === "string");

		// Add any/all accountDemographicForm input data
		this.updateAccountDemographics(data, selector ? (useSelectorFunction ? $(selector)[selectorFunctionName]() : $(selector)) : undefined)
			.always(() => {
				// Add any/all media selector input data
				mediaOutlet = this.getMediaOutlet();
				if (mediaOutlet) {
					data.mediaOutlet = mediaOutlet;
				}

				deferred.resolve(data);
			});

		return deferred;
	},

	// Used to get only the create account form data (name, address, email, phone, etc.)
	serializeCreateAccountFormOnly: function (options) {
		options = options || {};

		if (!options.accountFormId) {
			// if we didn't provide an accountFormId, assume we want the "primary" account form.
			options.accountFormId = this.getPrimaryCreateAccountFormId();
		}

		return this.serializeAddressForm(`[data-component='createAccountForm'][id='${options.accountFormId}'] form`, options);
	},

	serializeAddressForm: function (createAccountFormSelector, options) {
		options = options || {};
		var $form = $(createAccountFormSelector);
		var data = ActionsHelper.serializeForm($form);

		//Manually set/update the default billing and shipping
		if (data.address) {
			DefaultBillingAndShippingAddressHelper.serializeCheckboxes($form, data.address);
		}

		var account = AccountStore.get("account");

		if (
			data.haveAddressDefaultsChanged ||
			(
				account && account.address && data.address &&
				(
					(data.address.line1 || "") !== (account.address.line1 || "") ||
					(data.address.line2 || "") !== (account.address.line2 || "") ||
					(data.address.line3 || "") !== (account.address.line3 || "") ||
					(data.address.line4 || "") !== (account.address.line4 || "") ||
					(data.address.city || "") !== (account.address.city || "") ||
					(data.address.state || "") !== (account.address.state || "") ||
					(data.address.postalCode || "") !== (account.address.postalCode || "") ||
					(data.address.country || "") !== (account.address.country || "")
				)
			)
		 ) {
			data.address.hasAddressChanged = true;
		}

		// We cannot create an account without at least the country code.
		// Prep the address object so that we can set the default/unknown country if necessary.
		if (options.createAddressIfNotExists && !data.address) {
			data.address = {};
		}

		this.setSmartyStreetsFields(data, $form);
		this._verifyCountry(data, $form);

		if (options.shouldEncodePassword) {
			this.encodePassword(data);
			this.encodePassword(data, "confirmPassword");
		}

		return data;
	},

	setSmartyStreetsFields: function (data, $form) {
		if (!data || !data.address) {
			return;
		}

		var standardizationStatus;
		var standardizationMessage;
		if ($form.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.USER_CERTIFIED) === "true") {
			standardizationStatus = Constants.ADDRESS_VERIFICATION_STATUSES.USER_CERTIFIED;
		} else if ($form.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.VERIFIED) === "true") {
			standardizationStatus = Constants.ADDRESS_VERIFICATION_STATUSES.VERIFIED;
		} else if ($form.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.ERROR)) {
			standardizationStatus = Constants.ADDRESS_VERIFICATION_STATUSES.ERROR;
			standardizationMessage = $form.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.ERROR);
		}

		if (standardizationStatus) {
			//Only adding a standardization result when this was either user or SmartyStreets verified or if we got an error so Services Address Standardization does not occur.
			data.address.standardizationResult = {
				message: standardizationMessage,
				provider: Constants.ADDRESS_VERIFICATION_PROVIDERS.SMARTYSTREETS,
				status: standardizationStatus
			};
		}
	},

	_verifyCountry: function (data, $form) {
		if (!data || !data.address || data.address.country) {
			return;
		}

		// For now, we need to determine a) if the country component is present and b) if a postal code is present
		// * If we have postal code and no country code/no component use Default
		// * If no postal code and no country component use Unknown.
		var $countrySelector = $form.find("select[name='address.country']");

		if (!$countrySelector.length) {
			if (data && data.address && data.address.postalCode) {
				data.address.country = this.getDefaultCountry();
			} else {
				data.address.country = this.getUnknownCountry();
			}
		}
	},

	getDefaultCountry: function () {
		return window.AccountStore.getDefaultCountry();
	},

	getUnknownCountry: function () {
		return window.AccountStore.getUnknownCountry();
	},

	getMediaOutlet: function () {
		var $mediaInput = $("select[name=mediaOutlet]").last();

		if ($mediaInput.length) {
			return $mediaInput.val();
		}
		return undefined;
	},

	encodePassword: function (data, field) {
		if (!field) {
			field = "password";
		}

		if (!data || !data[field]) {
			return;
		}


		data[field] = btoa(data[field]);
	},

	// The form's parent should always be the component wrapper containing the form. We need to use the id of the parent,
	// not the form because the id of the form is always the componentName of it's parent. When there are multiple of the
	// same form on a layout (inside the AccountState Component for example) it is the parent's id which is unique, not the form's.
	getParentForm: function (reactComponent) {
		if (!reactComponent) {
			return $(null);
		}

		var $form = $(ReactDOM.findDOMNode(reactComponent)).closest("form");

		var formId = $form.attr("id");

		if (formId && formId.match(/_[a-z][0-9]/g)) {
			// We need to remove the GUID from the id before getting the parent
			formId = formId.substring(0, formId.lastIndexOf('_'));
		}

		var $parent = $form.closest(`[data-component="${formId}"]`);

		if (!$parent.length && formId) {
			if (formId.endsWith("Form")) {
				//To account for primaryContactInformationForm is the form id instead of just primaryContactInformation
				$parent = $form.closest(`[data-component="${formId.substring(0, formId.length - 4)}"]`);
			} else if (formId === "addOtherAddresses") {
				//To account for the otherAddresses add form
				$parent = $form.closest(`[data-component="otherAddresses.addForm"]`);
			} else if (formId.startsWith("editOtherAddresses")) {
				//To account for the otherAddresses edit form
				$parent = $form.closest(`[data-component="otherAddresses.populated.singleAddress.edit"]`);
			} else if (formId === "editMyMagazineEmail") {
				//To account for the myMagazineEmailSubscriptions edit form
				$parent = $form.closest("[data-component='myMagazineEmailSubscriptions.populated.singleMagazineEmail.edit']");
			} else if (formId === "editMyMagazineMail") {
				//To account for the myMagazineMailSubscriptions edit form
				$parent = $form.closest("[data-component='myMagazineMailSubscriptions.populated.singleMagazineMail.edit']");
			} else if (formId === "editMyMembership") {
				//To account for the myMembershipSubscription edit form
				$parent = $form.closest("[data-component='myMembershipSubscriptions.populated.singleMembership.edit']");
			} else if (formId === "editMyProduct") {
				//To account for the myProductSubscription edit form
				$parent = $form.closest("[data-component='myProductSubscriptions.populated.singleProduct.edit']");
			} else if (formId === "addBillingAddress") {
				$parent = $form.closest("[data-component='billingAddress.addForm']");
			}
		}

		return $parent;
	},

	getParentFormId: function (reactComponent) {
		var $formParent = this.getParentForm(reactComponent);

		return this.getParentFormIdFromForm($formParent);
	},

	getParentFormIdFromForm: function ($formParent) {
		return $formParent && $formParent.length > 0 ? $formParent.attr("id") || $formParent.attr("data-repeated-id") : null;
	},

	handleAccountCreateResponse: function (store, responseJSON, hideSpinner) {
		if (responseJSON) {
			if (typeof responseJSON !== "object") {
				responseJSON = JSON.parse(responseJSON);
			}
			var foundError = false;
			var message = responseJSON.message;

			if (message.indexOf("Passwords") !== -1 || responseJSON.messageGuaranteedConstituentSafe) {
				BootstrapPrompt.alert(window.AccountStore.getWizardValue(
					WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
					WizardConstants.ACCOUNT_MESSAGE_FIELDS.ACCOUNT_CREATE_ERROR,
					{ message }
				));
				foundError = true;
			} else {
				var messagesByField;

				if (responseJSON.response && Array.isArray(responseJSON.response.messagesByField)) {
					messagesByField = responseJSON.response.messagesByField;
				} else if (Array.isArray(responseJSON.messagesByField)) {
					messagesByField = responseJSON.messagesByField;
				}

				if (Array.isArray(messagesByField)) {
					messagesByField.forEach((messageByField) => {
						if (messageByField.field === "email" && Array.isArray(messageByField.messages)) {
							messageByField.messages.forEach((fieldMessage) => {
								if (!foundError && fieldMessage.indexOf("Passwords") !== -1) {
									BootstrapPrompt.alert(window.AccountStore.getWizardValue(
										WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
										WizardConstants.ACCOUNT_MESSAGE_FIELDS.ACCOUNT_CREATE_ERROR,
										{ message: fieldMessage }
									));
									foundError = true;
								}
							});
						}
					});
				}
			}

			//We have found and already alerted about an error; do not alert again.
			//Gross, but finding if there are any email errors to allow showing specific error messages.
			if (foundError) {
				if (hideSpinner) {
					Spinner.removeSpinner();
				}
				return;
			}
		}

		BootstrapPrompt.alert(window.AccountStore.getWizardValue(
			WizardConstants.WIZARDS.ACCOUNT_MESSAGES,
			WizardConstants.ACCOUNT_MESSAGE_FIELDS.ACCOUNT_CREATE_ERROR,
			{ message: "" }
		));

		if (hideSpinner) {
			Spinner.removeSpinner();
		}
	},

	// Used when the account demographic form is contained within another form or submitted with other data
	// This method takes accountData as a parameter because it may have to perform some cleanup on the data
	// in order to remove any extraneous account demographic properties which were previously added by jQuery's serializeForm()
	updateAccountDemographics: function (accountData, $form, shouldValidate) {
		var deferred = new $.Deferred();

		accountData = accountData || {};
		//We always want to get [data-component='singleCheckbox.input'] because it has a true/false value.
		AccountDemographicsHelper.getDemographics(
			$form ? $form.find("[data-component='accountDemographicsForm'] input[name].isDirty,select[name].isDirty,[data-component='singleCheckbox.input']") : undefined,
			shouldValidate
		)
			.always(codes => {
				if (codes && Array.isArray(codes) && codes.length > 0) {
					if (accountData.codes && Array.isArray(accountData.codes)) {
						accountData.codes = accountData.codes.concat(codes);
					} else {
						accountData.codes = codes;
					}

					accountData.codes.forEach(code => {
						if (accountData.hasOwnProperty(code.type)) {
							delete accountData[code.type];
						}
					});
				}
				deferred.resolve();
			});

		return deferred;
	},

	initializeAccountForm: function ($accountForm, accountData, formId) {
		formId = formId || $accountForm.attr("id");
		window.AccountActions.setSelectedTitle(formId, accountData.title);
		$accountForm.find("[data-component='accountFirstName']").val(accountData.firstName);
		$accountForm.find("[data-component='accountMiddleName']").val(accountData.middleName);
		$accountForm.find("[data-component='accountLastName']").val(accountData.lastName);
		$accountForm.find("[data-component='accountSuffix']").val(accountData.suffix);
		if (accountData.email) {
			$accountForm.find("[data-component='accountEmailAddress']").val(accountData.email.emailAddress);
		}
		if (accountData.address) {
			window.AccountActions.setSelectedCountry(formId, accountData.address.country);
			window.AccountActions.setSelectedState(formId, accountData.address.state);
			$accountForm.find("[data-component='accountAddressLine1']").val(accountData.address.line1);
			$accountForm.find("[data-component='accountAddressLine2']").val(accountData.address.line2);
			$accountForm.find("[data-component='accountAddressLine3']").val(accountData.address.line3);
			$accountForm.find("[data-component='accountAddressLine4']").val(accountData.address.line4);
			$accountForm.find("[data-component='accountAddressCity']").val(accountData.address.city);
			$accountForm.find("[data-component='accountAddressPostalCode']").val(accountData.address.postalCode);
		}
		if (accountData.phone) {
			$accountForm.find("[data-component='accountPhoneAreaCode']").val(accountData.phone.areaCode);
			$accountForm.find("[data-component='accountPhoneNumber']").val(accountData.phone.phoneNumber);
		}

		//This will also trigger the media filtering after the address is set.
		window.AccountActions.setSelectedMediaOutlet(accountData.mediaOutlet);
	},

	initializeAccountFormListeners: function (callbackFunction) {
		callbackFunction = callbackFunction || function () { };

		//We set up these listeners after the DOM is loaded because react components have not been rendered yet.
		document.addEventListener("DOMContentLoaded", () => {
			var createAccountFormSelector = "#createAccountForm";
			$(`${createAccountFormSelector} input[data-component='accountAddressLine1'],${createAccountFormSelector} input[data-component='accountAddressCity']`)
				.change(() => callbackFunction());
			$(`${createAccountFormSelector} [data-shared-name='address.state.field'],${createAccountFormSelector} input[data-component='accountAddressPostalCode']`)
				.change(() => callbackFunction());
			$(`${createAccountFormSelector} select[name='address.country']`)
				.change(() => callbackFunction());

			//ShipTo For Gift Account
			var createGiftAccountFormSelector = "#createGiftAccountForm";
			$(`${createGiftAccountFormSelector} input[data-component='accountAddressLine1'],${createGiftAccountFormSelector} input[data-component='accountAddressCity']`)
				.change(() => callbackFunction());
			$(`${createGiftAccountFormSelector} [data-shared-name='address.state.field'],${createGiftAccountFormSelector} input[data-component='accountAddressPostalCode']`)
				.change(() => callbackFunction());
			$(`${createGiftAccountFormSelector} select[name='address.country']`)
				.change(() => callbackFunction());

			//For shipToOtherAddress
			var otherAddressAddFormSelector = "#addOtherAddresses";
			$(`${otherAddressAddFormSelector} input[data-component='accountAddressLine1'],${otherAddressAddFormSelector} input[data-component='accountAddressCity']`)
				.change(() => callbackFunction());
			$(`${otherAddressAddFormSelector} [data-shared-name='address.state.field'],${otherAddressAddFormSelector} input[data-component='accountAddressPostalCode']`)
				.change(() => callbackFunction());
			$(`${otherAddressAddFormSelector} select[name='address.country']`)
				.change(() => callbackFunction());

			//For the Billing Address Add Form
			var billingAddressAddFormSelector = "#addBillingAddress";
			$(`${billingAddressAddFormSelector} input[data-component='accountAddressLine1'],${billingAddressAddFormSelector} input[data-component='accountAddressCity']`)
				.change(() => callbackFunction());
			$(`${billingAddressAddFormSelector} [data-shared-name='address.state.field'],${billingAddressAddFormSelector} input[data-component='accountAddressPostalCode']`)
				.change(() => callbackFunction());
			$(`${billingAddressAddFormSelector} select[name='address.country']`)
				.change(() => callbackFunction());

			//shipToComponent
			$("input[type='radio'][name='shipToAddressSelector']").change((event) => {
				if ($(event.currentTarget).is(":checked")) {
					callbackFunction();
				}
			});

			//Other Addresses
			$("[data-dynamic-href='cancelAddOtherAddress']").change(() => callbackFunction());
			$("input[type='radio'][name='otherAddressesSelector']").change((event) => {
				if ($(event.currentTarget).is(":checked")) {
					callbackFunction();
				}
			});

			this.initializeAccountEmailCustomValidator();
		});
	},

	initializeAccountEmailCustomValidator: function () {
		//Add custom regex validator for email address
		$("input[data-component='accountEmailAddress']")
			.attr("data-has-custom-validator", true)
			.each((index, emailAddressElement) => {
				var $emailAddress = $(emailAddressElement);
				$emailAddress.data({
					customValidator: this.validateEmailAddress.bind(this, $emailAddress)
				});
			});
	},

	validateEmailAddress: function($emailAddressElement) {
		var errorMessages = [];
		var emailAddress = $emailAddressElement.val();

		if (emailAddress != null && emailAddress != "" && !RegExpHelper.isEmail(emailAddress)) {
			errorMessages.push(window.FORM_VALIDATION_MESSAGES.INVALID_EMAIL);
		}

		return {
			errorMessages,
			isValid: !errorMessages.length
		};
	},

	hasPopulatedAccountForm: function () {
		var hasGiftAccount = false;
		var hasOtherAddress = false;
		var hasCreateAccount = false;
		var loggedIn = false;

		// ShipTo For Gift Account
		var createGiftAccountFormSelector = "#createGiftAccountForm";
		var $createGiftAccountForm = $(`${createGiftAccountFormSelector}:visible`);
		hasGiftAccount = this.isFormPopulated($createGiftAccountForm);

		// ShipTo Other Address
		var otherAddressAddFormSelector = "#addOtherAddresses";
		var $otherAddressEditForm = $(`${otherAddressAddFormSelector}:visible`);
		hasOtherAddress = this.isFormPopulated($otherAddressEditForm);

		// CreateAccount Form
		var createAccountFormSelector = "#createAccountForm";
		var $createAccountForm = $(`${createAccountFormSelector}:visible`);
		hasCreateAccount = this.isFormPopulated($createAccountForm);

		if (!hasCreateAccount) {
			// we don't have a default createAccount form on the page. We're logged in.
			var $savedPayments = $(`[data-component="savedPayments"]:visible`);
			if ($savedPayments.length) {
				loggedIn = true;
			}
		}

		// if we have a gift or other component, we need to determine which radio button is selected.
		// That way we can correctly identify when we have a shippable address.
		var shipToSelection = $("input[type='radio'][name='shipToAddressSelector']:checked").val();
		if (!shipToSelection || shipToSelection === "primary") {
			// we either don't have a selector or we're using primary
			return hasCreateAccount || loggedIn;
		}

		if (shipToSelection === "gift") {
			return hasGiftAccount;
		}

		if (shipToSelection === "other") {
			// is the new address selected?
			if ($('[data-component="otherAddresses.addForm.radio"]:checked').length) {
				return hasOtherAddress;
			} else if ($("input[name='otherAddressesSelector']:checked").val() === "on") {
				return true;
			}
		}
	},

	isFormPopulated: function ($formSelector) {
		if (!$formSelector.length) {
			return false;
		}

		var accountObject = {};
		accountObject.line1 = $formSelector.find("input[data-component='accountAddressLine1']").val();
		accountObject.city = $formSelector.find("input[data-component='accountAddressCity']").val();
		accountObject.state = $formSelector.find("[name='address.state']").val(); // will find either the select or text input, but not both.
		accountObject.zip = $formSelector.find("input[data-component='accountAddressPostalCode']").val();

		if (accountObject.line1 &&
			accountObject.city &&
			accountObject.state &&
			accountObject.zip) {
			return true;
		}

		return false;
	},

	/**
	 * Validates
	 * @param event
	 * @param options
	 * @returns {jQuery.Deferred}
	 */
	validateShippingAddress: function(event, options) {
		options = options || {};
		var { checkoutStoreRef } = options;
		var deferred = new $.Deferred();

		var shippingAddressType = $("[data-component='shipToAddressSelector'] input[type='radio'][name='shipToAddressSelector']:checked").val();

		if (options.bypassShippingValidation) {
			deferred.resolve(shippingAddressType);
			return deferred;
		}

		//Check to make sure a shipping method is selected if required
		var isShippingMissingResult = checkoutStoreRef.getIsShippingMethodRequiredAndMissing();
		if (isShippingMissingResult.isMissing) {
			deferred.reject(isShippingMissingResult.errorMessage);
			return deferred;
		}

		switch (shippingAddressType) {
			case "gift":
				var $createGiftAccountForm = $("[data-component='createGiftAccountForm']");

				if ($createGiftAccountForm.length > 0) {
					if ($createGiftAccountForm.find("form [name='firstName']").val() && $createGiftAccountForm.find("form [name='lastName']").val()) {
						window.SmartyStreets.verifyAddress("createGiftAccountForm").done(() => {
							deferred.resolve(shippingAddressType);
						}).fail(err => {
							deferred.reject(err);
						});
					} else {
						deferred.reject(checkoutStoreRef.getWizardValue(
							WizardConstants.WIZARDS.SHIPPING_MESSAGES,
							WizardConstants.SHIPPING_MESSAGE_FIELDS.GIFT_RECIPIENT_MISSING
						));
					}
				} else {
					LoggerInstance.error("Give as a gift option is selected, but the gift account form does not exist!");
					deferred.reject();
				}

				break;
			case "other":
				var isAddFormUsedForAdd = false;

				if ($("[data-component='otherAddresses.addForm']").attr("data-address-id")) {
					deferred.reject(checkoutStoreRef.getWizardValue(
						WizardConstants.WIZARDS.SHIPPING_MESSAGES,
						WizardConstants.SHIPPING_MESSAGE_FIELDS.SHIPPING_ADDRESS_INCOMPLETE
					));
					return deferred;
				}

				if (!$("[data-component='otherAddresses.populated.singleAddress.view'] input[type='radio'][name='otherAddressesSelector']:checked").length &&
					!$("[data-component='otherAddresses.addForm'] input[type='radio'][name='otherAddressesSelector']:checked").length) {
					deferred.reject(checkoutStoreRef.getWizardValue(
						WizardConstants.WIZARDS.SHIPPING_MESSAGES,
						WizardConstants.SHIPPING_MESSAGE_FIELDS.SHIPPING_ADDRESS_MISSING
					));
					return deferred;
				}

				if ($("[data-component='otherAddresses.addForm'] input[type='radio'][name='otherAddressesSelector']:checked").length) {
					var $addressForm = $("[data-component='otherAddresses.addForm']");
					if (!$addressForm.find("[data-component='accountAddressLine1']").val() && !$addressForm.find("[data-component='accountAddressCity']").val()) {
						deferred.reject(checkoutStoreRef.getWizardValue(
							WizardConstants.WIZARDS.SHIPPING_MESSAGES,
							WizardConstants.SHIPPING_MESSAGE_FIELDS.NEW_SHIPPING_ADDRESS_INCOMPLETE
						));
						return deferred;
					}
					isAddFormUsedForAdd = true;
				}

				if (isAddFormUsedForAdd) {
					window.SmartyStreets.verifyAddress("otherAddressesAdd").done(() => {
						deferred.resolve(shippingAddressType);
					}).fail((error) => {
						deferred.reject(error);
					});
				} else {
					deferred.resolve(shippingAddressType);
				}
				break;
			default:
				if (options.primaryAddressFormName) {
					window.SmartyStreets.verifyAddress(options.primaryAddressFormName).done(() => {
						deferred.resolve(shippingAddressType);
					}).fail((error) => {
						deferred.reject(error);
					});
				} else {
					deferred.resolve(shippingAddressType);
				}
				break;
		}

		return deferred;
	},

	validateOneTimePassword: function (event) {
		var deferred = new $.Deferred();

		// send the request to the server to generate the one-time password
		// if that succeeds, open the modal
		window.OneTimePasswordHelper.verifyOneTimePassword(deferred)
		.done((oneTimePassword) => {
			deferred.resolve(oneTimePassword);
		}).fail((error) => {
			deferred.reject(error);
		});

		return deferred;
	},

	validatePrimaryAddress: function(options) {
		options = options || {};
		var { primaryAddressFormName } = options;
		var deferred = new $.Deferred();

		if (primaryAddressFormName) {
			window.SmartyStreets.verifyAddress(primaryAddressFormName).done(() => {
				deferred.resolve(primaryAddressFormName);
			}).fail((error) => {
				deferred.reject(error);
			});
		} else {
			deferred.resolve(primaryAddressFormName);
		}

		return deferred;
	}
};